import {
  type ConversationMetadata,
  type DataPayload,
  type MessagingChatAuth,
} from 'types/customEventData';

export abstract class AbstractChatClient {
  /**
   * Applies the tags and Zendesk custom fields the ticket should open with.
   * Both travel together: Zendesk stamps them onto the ticket when the
   * conversation is created, so a second pass would come too late.
   */
  abstract setConversationMetadata(
    metadata: ConversationMetadata,
  ): Promise<void> | void;

  abstract identify(
    payload?: DataPayload['visitor_info'] | MessagingChatAuth,
  ): Promise<void> | void;

  abstract logout(): Promise<void> | void;

  abstract hideWidget(): Promise<void> | void;

  abstract openWidget(): void;
}
